import { module } from 'modujs';
import {gsap} from 'gsap';
import { MorphSVGPlugin } from "../vendors/gsap/MorphSVGPlugin";
import drawSvgPlugin from '../vendors/gsap/DrawSVGPlugin';
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");
import emitter from 'tiny-emitter/instance';
import Utils from "../utils/utils";

export default class extends module {
  constructor(m)
  {
    super(m);

    this.header = this.el
    this.headerContent = this.header.querySelector('.header__content')
    this.headerTitle = this.header.querySelector('.header__title')

    this.tweenArray = []
    //console.log("✅HEADER✅")
  }

  init(){


    if(!Utils.isMobile()) {

      let tween = gsap.to(this.headerContent, {
        yPercent: 15,
        ease: "none",
        scrollTrigger: {
          trigger: this.header,
          start: '10%',
          scrub: true,
        }
      });
      this.tweenArray.push(tween)

      let tween2 = gsap.to(this.headerTitle, {
        yPercent: 100,
        ease: "none",
        scrollTrigger: {
          trigger: this.header,
          start: '10%',
          scrub: true,
        }
      });

      this.tweenArray.push(tween2)
    }


    if(Utils.isMobile()) {
      ScrollTrigger.create({
        trigger: this.header,
        start : "top top",
        end : "bottom top",
        onLeave: () => {
          emitter.emit('mobileNavbar::show')
        },
        onEnterBack: () => {
          emitter.emit('mobileNavbar::hide')
        }
      })
    }


    // window.addEventListener('resize', this.appHeight);
    this.appHeight();

  }

  appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
  }


  destroy() {
    // destroy method
    this.tweenArray[0].kill()
    //console.log('DESTROYED tweens')
    // window.removeEventListener('resize', this.appHeight);
  }

}





// WEBPACK FOOTER //
// ./scripts/modules/header.js